/* tslint:disable */

declare var Object: any;
export interface SFSptMasaInterface {
  "id"?: number;
}

export class SFSptMasa implements SFSptMasaInterface {
  "id": number;
  constructor(data?: SFSptMasaInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFSptMasa`.
   */
  public static getModelName() {
    return "SFSptMasa";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFSptMasa for dynamic purposes.
  **/
  public static factory(data: SFSptMasaInterface): SFSptMasa{
    return new SFSptMasa(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFSptMasa',
      plural: 'SFSptMasas',
      path: 'SFSptMasas',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFSptMasa.ts